<template>
    <div class="page">
        <v-toolbar v-if="!isAuthed" color="white" dark elevation="0" height="80" style="border-bottom: 1px solid rgba(0,0,0, 0.2)!important;" class="mb-5">
            <v-container>
                <logo link :height="60" />
            </v-container>
        </v-toolbar>
        <v-container class="py-3 py-lg-6">


            <v-card v-if="pageData" :class="{'py-2 px-3 bordered': pcOnly}" flat>
                <v-card-title :class="{'px-2': phoneOnly}">Terms And Conditions</v-card-title>
                <v-card-text :class="{'px-2': phoneOnly}">
                    <p v-if="pageData.text" class="text--text medium-text" style="white-space: pre-line; line-height: 1.9" v-html="urlify(escapeHtmlText(pageData.text))"></p>
                    <div v-else>_______</div>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import Logo from '@/components/main/logo'

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';


export default {
    components: {
        Logo        
    },
    data(){
        return {
            loading: false,
            pageData: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,

        getPageData(){
            if (!this.loading){
                this.loading = true;
                const url = '/terms';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.pageData = response.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
    },
    mounted(){
        if (!this.pageData){
            this.getPageData();
        }
    }
}
</script>